import React from 'react';
import { IconProps } from '../types/Icon';

export default function ProgressSpinnerIcon({ height = 19, width = 18, colour = '#fff' }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.1233 13.2105C16.4075 14.7111 15.2901 15.9841 13.895 16.8884C12.4998 17.7926 10.8815 18.2927 9.2194 18.3333C7.55734 18.3738 5.91654 17.9531 4.47897 17.118C3.04141 16.2828 1.86327 15.0658 1.07523 13.6019C0.287197 12.1379 -0.0799388 10.4843 0.0145456 8.82446C0.10903 7.16459 0.661442 5.56333 1.61051 4.19829C2.55958 2.83324 3.86821 1.75775 5.39127 1.09112C6.91432 0.424483 8.59226 0.192752 10.239 0.421628L10.0989 1.42976C8.63837 1.22677 7.15019 1.4323 5.79938 2.02354C4.44858 2.61479 3.28794 3.56864 2.4462 4.77931C1.60447 5.98998 1.11453 7.41015 1.03073 8.8823C0.946929 10.3545 1.27254 11.821 1.97146 13.1194C2.67038 14.4178 3.71527 15.4972 4.99026 16.2379C6.26525 16.9786 7.72049 17.3517 9.19459 17.3157C10.6687 17.2798 12.104 16.8362 13.3414 16.0343C14.5788 15.2323 15.5698 14.1032 16.2046 12.7723L17.1233 13.2105Z"
                fill={colour}
            />
        </svg>
    );
}
